import {t} from "i18next";

export const translateRecharge = str => {
  switch (str) {
    case "Alle 30 Tage":
      return t("subscription.delivery_30_day");
    case "Alle 60 Tage":
        return t("subscription.delivery_60_day");
    case "Alle 90 Tage":
      return t("subscription.delivery_90_day");
    case "Alle 120 Tage":
      return t("subscription.delivery_120_day");
    case "30-day":
      return t("subscription.add_to_cart.30_day");
    case "60-day":
      return t("subscription.add_to_cart.60_day");
    case "90-day":
      return t("subscription.add_to_cart.90_day");
    case "120-day":
      return t("subscription.add_to_cart.120_day");
    default:
      return str;
  }
};
